export function getElementById(id: string) {
  return typeof document === "object" ? document.getElementById(id) : undefined;
}

export function getElementBoundaryById(id: string, boundary: "top" | "bottom" | "left" | "right") {
  const elt = getElementById(id);

  if (!elt) {
    return undefined;
  }

  const rect = elt.getBoundingClientRect();

  if (!rect) {
    return undefined;
  }

  return rect[boundary];
}

/**
 * Returns true if the currently focused element is an input-like element.
 *
 * Covers:
 * - <input>
 * - <textarea>
 * - <select>
 * - contenteditable elements
 */
export function isInputFocused(): boolean {
  if (typeof document === "undefined") {
    return false;
  }

  const activeElement = document.activeElement;

  if (!activeElement) {
    return false;
  }

  return (
    activeElement instanceof HTMLInputElement ||
    activeElement instanceof HTMLTextAreaElement ||
    activeElement instanceof HTMLSelectElement ||
    (activeElement instanceof HTMLElement && activeElement.isContentEditable)
  );
}
